import { isDefined, isSameId } from "../../helpers";
import { getNextTaskId } from "./common";
import { uid } from "@xbs/lib-state";
export function checkSelectedTasks({ store }) {
    const selected = store.getState().selected;
    let $meta;
    if (selected.length > 1) {
        $meta = { batch: uid() };
    }
    store.eachSelected(id => {
        checkTask({ store, id, $meta });
    }, true);
}
export function checkTask({ store, id, $meta }) {
    const task = store.getTask(id);
    if (!task || task.checked)
        return;
    const { taskShape } = store.getState();
    if (taskShape?.completed?.taskHide) {
        let nextSelect = null;
        const parents = store.getParentIds(id);
        const rootParent = parents[parents.length - 1];
        const rootTasks = store.getChildren({
            filtered: true,
            hideCompleted: true,
        });
        const rootTaskIndex = rootTasks.findIndex(t => isSameId(t.id, rootParent));
        nextSelect = getNextTaskId({ store, id });
        store.in.exec("check-task", { id, $meta });
        if (store.getTask(rootParent)?.checked) {
            const nextTaskId = rootTasks[rootTaskIndex + 1]?.id;
            const lastTaskId = rootTasks[rootTaskIndex - 1]?.id;
            nextSelect = isDefined(nextTaskId) ? nextTaskId : lastTaskId;
        }
        else if (store.getTask(nextSelect)?.checked) {
            nextSelect = getNextTaskId({ store, id: nextSelect });
        }
        isDefined(nextSelect) &&
            store.in.exec("select-task", {
                id: nextSelect,
            });
    }
    else {
        store.in.exec("check-task", { id, $meta });
    }
}
//# sourceMappingURL=check.js.map